<template>
  <section id="dashboard-ecommerce">
    <b-overlay :show="onProgress">
      <b-row class="match-height">
        <b-col cols="12">
          <statistics :data="data.statistics"/>
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="6" v-if="!onProgress && data.openTickets.length">
          <tickets :table-data="data.openTickets" title="کاربران دارای بیشترین تیکت باز"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.sentTickets.length">
          <tickets :table-data="data.sentTickets" title="کاربران داری بیشترین تیکت های ارسالی"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.inboxTickets.length">
          <tickets :table-data="data.inboxTickets" title="کاربران داری بیشترین تیکت های ورودی"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.replyTickets.length">
          <tickets :table-data="data.replyTickets" title="کاربران داری بیشترین تیکت های پاسخ داده شده"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.forwardTickets.length">
          <tickets :table-data="data.forwardTickets" title="کاربران داری بیشترین تیکت های بازارسال شده"/>
        </b-col>

      </b-row>
    </b-overlay>

  </section>
</template>

<script>
import { BRow, BCol, BOverlay } from 'bootstrap-vue'

import Statistics from './statistics.vue'
import tickets from '@/views/report/ticket/ticketsTable.vue'

import { doubleRaf } from '@/libs/utils'

export default {
  components: {
    BRow,
    BCol,
    Statistics,
    tickets,
    BOverlay
  },
  data() {
    return {
      data: {},
      onProgress: false
    }
  },
  created() {
    // data
    this.onProgress = true

    this.$http.get('/reports/tickets')
        .then((response) => {
          this.data = response.data

          doubleRaf(() => {
            this.onProgress = false
          })
        })
  },
}
</script>
